import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { lessons: Array, selectedIds: Array }
  static targets = ["toggle", "label", "list"]

  connect() {
    this.#render()
  }

  updateLabel() {
    this.#syncLabel()
  }

  #render() {
    const checkedIds = new Set(this.selectedIdsValue.map(String))
    const videos = this.lessonsValue.filter(l => l.primary_type === "video")
    const worksheets = this.lessonsValue.filter(l => l.primary_type === "worksheet")
    const other = this.lessonsValue.filter(l => l.primary_type !== "video" && l.primary_type !== "worksheet")

    const renderCheckboxes = (lessons) => lessons.map(l => `
      <label class="d-flex align-items-center gap-2 py-1 px-2" for="lesson_sheet_lesson_${l.id}">
        <input type="checkbox" name="lesson_sheet[lesson_ids][]" value="${l.id}" id="lesson_sheet_lesson_${l.id}"${checkedIds.has(String(l.id)) ? " checked" : ""}>
        <span class="small">${this.#esc(l.title)}</span>
      </label>
    `).join("")

    const renderColumn = (label, lessons) => lessons.length === 0 ? "" : `
      <div class="col-6">
        <div class="fw-bold text-muted small mb-1">${label}</div>
        ${renderCheckboxes(lessons)}
      </div>
    `

    this.listTarget.innerHTML = `
      <li class="px-3 py-2">
        <div class="row">
          ${renderColumn("Video Lessons", videos)}
          ${renderColumn("Worksheet Lessons", worksheets)}
        </div>
        ${other.length > 0 ? `
          <div class="mt-2">
            <div class="fw-bold text-muted small mb-1">Other Lessons</div>
            ${renderCheckboxes(other)}
          </div>
        ` : ""}
      </li>
    `

    this.#syncLabel()
  }

  #syncLabel() {
    const count = this.listTarget.querySelectorAll("input:checked").length
    this.labelTarget.textContent = count > 0 ? `${count} lesson${count === 1 ? "" : "s"} selected` : "Select Lessons"
  }

  #esc(str) {
    return str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;")
  }
}
